let secureDfuLoadPromise = null;

const R6_DFU_SERIAL_FILTERS = [
  // Nordic Secure DFU bootloader USB identity.
  { usbVendorId: 0x1915, usbProductId: 0x521f },
];

async function getSecureDfuApi() {
  if (typeof window !== "undefined" && window.AngryMiaoSecureDfu?.update) {
    return window.AngryMiaoSecureDfu;
  }
  if (typeof document === "undefined") {
    throw new Error("Secure DFU 模块无法在当前环境加载");
  }
  if (!secureDfuLoadPromise) {
    secureDfuLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `${process.env.BASE_URL}vendor/angrymiao-secure-dfu.js`;
      script.async = true;
      script.onload = resolve;
      script.onerror = () =>
        reject(new Error(`Secure DFU 脚本加载失败：${script.src}`));
      document.head.appendChild(script);
    }).catch((error) => {
      secureDfuLoadPromise = null;
      throw error;
    });
  }
  await secureDfuLoadPromise;
  const api = window.AngryMiaoSecureDfu;
  if (!api || typeof api.update !== "function") {
    secureDfuLoadPromise = null;
    throw new Error("Secure DFU 脚本未提供固件更新接口");
  }
  return api;
}

export async function requestCyberboardR6DfuPort() {
  const api = await getSecureDfuApi();
  if (typeof api.requestPort !== "function") {
    throw new Error("Secure DFU 模块不支持选择升级串口");
  }
  return api.requestPort(R6_DFU_SERIAL_FILTERS);
}

export async function validateCyberboardR6FirmwarePackage(file) {
  if (!file) throw new TypeError("请选择 R6 固件 ZIP 包");
  const api = await getSecureDfuApi();
  if (typeof api.validatePackage !== "function") {
    throw new Error("Secure DFU 模块不支持固件包校验");
  }
  return api.validatePackage(file);
}

export function updateCyberboardR6Firmware(file, options = {}) {
  if (!file) throw new TypeError("请选择 R6 固件 ZIP 包");
  return getSecureDfuApi().then((api) => api.update(file, options));
}

const wait = (milliseconds) =>
  new Promise((resolve) => setTimeout(resolve, milliseconds));

export async function waitForCyberboardR6Reconnect(
  bridge,
  { timeoutMs = 30000, intervalMs = 350 } = {}
) {
  if (!bridge || typeof bridge.connectExisting !== "function") {
    throw new TypeError("R6 CDC bridge is required");
  }
  const deadline = Date.now() + timeoutMs;
  let lastError;
  while (Date.now() < deadline) {
    try {
      const port = await bridge.connectExisting();
      if (port && typeof bridge.identify === "function") {
        const info = await bridge.identify();
        return { port, info };
      }
    } catch (error) {
      lastError = error;
      if (bridge.isConnected && typeof bridge.disconnect === "function") {
        await bridge.disconnect().catch(() => {});
      }
    }
    await wait(Math.min(intervalMs, Math.max(0, deadline - Date.now())));
  }
  throw new Error(
    lastError
      ? `等待 R6 设备重新连接超时：${lastError.message}`
      : "等待 R6 设备重新连接超时"
  );
}
